import { saveAddressApi } from '../../api/address.api'
import { analytics } from '../../services/Analytics/Analytics'
import { readMobxSnapshot } from 'utils/mobx/readOutsideReaction'

export default async function syncAddress(api, currentAccount, addressStore) {
  let localAddress = readMobxSnapshot(
    () => addressStore.currentNormalizedAddress
  )

  if (currentAccount.address?.country && !localAddress) {
    analytics.track('Restored address')

    // Always use the combined setter path
    addressStore.setAddressFromServer(currentAccount.address)
  }

  addressStore.removeAddressIfNotSupported()

  localAddress = readMobxSnapshot(() => addressStore.currentNormalizedAddress)

  if (
    localAddress &&
    (!currentAccount.address ||
      JSON.stringify(
        currentAccount.address,
        Object.keys(localAddress).sort()
      ) !== JSON.stringify(localAddress, Object.keys(localAddress).sort()))
  ) {
    await api.call(saveAddressApi(localAddress))
  }
}
